import React, { FC } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';

type DeleteDraftIconButtonProps = {
    onDeleteDraftOrder?: () => void;
};
const DeleteDraftIconButton: FC<DeleteDraftIconButtonProps> = ({ onDeleteDraftOrder }: DeleteDraftIconButtonProps) => {
    const { t: translate } = useTranslation(['orders']);
    return (
        <Tooltip title={<span>{translate('orders:DELETE_ORDER')}</span>}>
            <IconButton
                size="small"
                onClick={(e) => {
                    e.stopPropagation();
                    if (onDeleteDraftOrder) {
                        onDeleteDraftOrder();
                    }
                }}
            >
                <DeleteIcon />
            </IconButton>
        </Tooltip>
    );
};

export default DeleteDraftIconButton;
